module.exports = __webpack_public_path__ + "static/img/mall-bg.25539b49.png";